import CorporateDataService from "../../../../context/corporates.services";

export const UpdateMethodPayment = async ({ id, value, enqueueSnackbar, setIsLoading }) => {
    try {
        if(value !== ''){
            setIsLoading(true);
            await CorporateDataService.updateCorporate('paiement', value, id);
            enqueueSnackbar(`Le mode de paiement a été passé à ${value}.`, {
                variant: 'success',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
                style: {fontSize: '1.6rem'}
                   
            });
            return true;
        }else{
            enqueueSnackbar(`Veuillez séléctionner une valeur`, {
                variant: 'error',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
                style: {fontSize: '1.6rem'}  
            });
        }
    }catch(e) {
        enqueueSnackbar(`${e.message}`, {
            variant: 'error',
            anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
            autoHideDuration: 3000,
            style: {fontSize: '1.6rem'}  
        });
        setIsLoading(false)
        return false;
    }
};